module.exports = __webpack_public_path__ + "d58eff5cfb2f3b08f8b3ba23d0467e43.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-420.webp
// module id = 621
// module chunks = 0